import { AlertTriangle } from "lucide-react";

export const getBackorderLines = (order) => (order?.satirlar || []).filter(
  (line) => Number(line.bakiyeye_alinan || 0) > 0
);

export const hasBackorder = (order) => Boolean(order?.bakiyeli_siparis) || getBackorderLines(order).length > 0;

export default function BackorderBadge({ order, compact = false }) {
  if (!hasBackorder(order)) return null;
  const count = getBackorderLines(order).length;
  const label = compact ? "Bakiyeli" : `Bakiyeli${count ? ` · ${count} ürün` : ""}`;

  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-700" title="Bu siparişte stoktan karşılanamayan ürün bulunuyor">
      <AlertTriangle size={12} />
      {label}
    </span>
  );
}
